import { __rest } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import getApiUrl from "../../common/getApiUrl";
import trimValues from "../../common/trimValues";
export const axiosInstance = axios.create();
/**
 * Utility function for making request by wrapping standard axios methods.
 * Requires Axios v 1.4.0 or higher.
 * @param {object} request - Request object containing parameters.
 * @param {*} request.method - Request method to call.
 * @returns {Promise<object>} Axios instance containing.
 */
const makeRequest = ({ method }) => (endpoint, _a = {}) => {
    var { data = {}, headers = {}, params = {}, timeout = 0, shouldTrimData = true, shouldRemoveData = false } = _a, options = __rest(_a, ["data", "headers", "params", "timeout", "shouldTrimData", "shouldRemoveData"]);
    return axiosInstance(Object.assign(Object.assign({ method, url: getApiUrl(endpoint, options) }, (!shouldRemoveData ? { data: shouldTrimData ? trimValues(data) : data } : {})), { headers: Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, headers), params,
        timeout }));
};
export default makeRequest;
//# sourceMappingURL=makeRequest.js.map